import { useEffect, useState, useCallback } from 'react';
import { listScanRows, toggleScanRowExclude } from '../api/payroll';

// BƯỚC 2b — RÀ SOÁT ĐƠN ĐÃ QUÉT trước khi tính lương.
// Kế toán trưởng tìm mã đơn -> bấm "Loại trừ" để bỏ đơn đó khỏi tính lương (mất TOÀN BỘ: mua hộ +
// cước + phụ thu + COD). Cờ nằm trên bản ghi doanh thu -> QUÉT LẠI là mất, phải loại trừ lại từ đầu.
// Bấm "Tính lương" xong -> bản doanh thu CHỐT CỨNG, không sửa được nữa (locked).
const vnd = (n) => Math.round(Number(n) || 0).toLocaleString('vi-VN');
const tr = (n) => `${(Number(n || 0) / 1e6).toLocaleString('vi-VN', { maximumFractionDigits: 1 })}tr`;

const FILTERS = [
  ['all', 'Tất cả'],
  ['suggest', '⚠ Gợi ý loại trừ'],
  ['refunded', 'Đã giảm trừ'],
  ['virtual', 'Đơn ảo'],
  ['cod', 'COD'],
  ['excluded', 'Đã loại trừ'],
];

export default function ScanRowsReview({ month }) {
  const [data, setData] = useState({ rows: [], total: 0, stats: {}, locked: false });
  const [q, setQ] = useState('');
  const [qInput, setQInput] = useState('');
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    setLoading(true); setErr('');
    try {
      setData(await listScanRows(month, { page, size, q, filter }));
    } catch (e) {
      setErr(e?.response?.data?.message || e.message);
    }
    setLoading(false);
  }, [month, page, size, q, filter]);

  useEffect(() => { load(); }, [load]);
  // Đổi tháng/bộ lọc/tìm kiếm -> về trang 1 (nếu không sẽ hiện trang trống).
  useEffect(() => { setPage(1); }, [month, filter, q, size]);

  const doSearch = (e) => { e.preventDefault(); setQ(qInput.trim()); };

  const toggle = async (row) => {
    try {
      const r = await toggleScanRowExclude(row._id, !row.excluded);
      setData((d) => ({
        ...d,
        rows: d.rows.map((x) => (x._id === r.id ? { ...x, excluded: r.excluded, excludedBy: r.excludedBy, excludedAt: r.excludedAt } : x)),
      }));
      load(); // nạp lại để cập nhật ô thống kê + bộ lọc "đã loại trừ"
    } catch (e) {
      alert(e?.response?.data?.message || e.message);
    }
  };

  const s = data.stats || {};
  const pages = Math.max(1, Math.ceil((data.total || 0) / size));

  return (
    <div className="scanrows">
      {data.locked && (
        <div className="scanrows-lock">
          🔒 Doanh thu tháng {month} đã CHỐT để tính lương — không sửa được. Muốn sửa phải quét lại doanh thu (sẽ phải loại trừ lại từ đầu).
        </div>
      )}

      <div className="scanrows-stats">
        <div className="srs-card"><div className="srs-lbl">Đơn quét được</div><div className="srs-val">{vnd(s.orders)}</div></div>
        <div className="srs-card"><div className="srs-lbl">Đã giảm trừ</div><div className="srs-val warn">{vnd(s.refunded)}</div></div>
        <div className="srs-card" title="Đơn nghi THANH TOÁN HỘ (tên hàng/ghi chú có 'thanh toán thuế', 'TT COD'…) chưa được loại trừ — bấm lọc '⚠ Gợi ý loại trừ' để xử lý">
          <div className="srs-lbl">Gợi ý loại trừ</div><div className="srs-val warn">{vnd(s.suggest)}</div>
        </div>
        <div className="srs-card"><div className="srs-lbl">Loại trừ tay</div><div className="srs-val danger">{vnd(s.excluded)}</div></div>
        <div className="srs-card"><div className="srs-lbl">DT sau loại trừ</div><div className="srs-val">{tr(s.dt)}</div></div>
      </div>

      <div className="scanrows-bar">
        <form onSubmit={doSearch} className="srb-search">
          <input value={qInput} onChange={(e) => setQInput(e.target.value)} placeholder="Mã đơn hàng, PXK, mã KH, nhân viên…" />
          <button type="submit">Tìm</button>
          {q && <button type="button" onClick={() => { setQInput(''); setQ(''); }}>Xoá</button>}
        </form>
        <div className="srb-filters">
          {FILTERS.map(([k, lbl]) => (
            <button key={k} className={filter === k ? 'active' : ''} onClick={() => setFilter(k)}>{lbl}</button>
          ))}
        </div>
      </div>

      {err && <div className="scanrows-err">{err}</div>}

      <div className="scanrows-tblwrap">
        <table className="scanrows-tbl">
          <thead>
            <tr>
              <th>Mã đơn hàng</th>
              <th>Khách / NV</th>
              <th className="r">Mua hộ</th>
              <th className="r">Cước</th>
              <th className="r">Phụ thu</th>
              <th>Ghi chú</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} className="srt-empty">Đang tải…</td></tr>}
            {!loading && !data.rows.length && <tr><td colSpan={7} className="srt-empty">Không có đơn nào khớp.</td></tr>}
            {!loading && data.rows.map((r) => (
              <tr key={r._id} className={r.excluded ? 'excluded' : ''}>
                <td className="mono">
                  {r.productCode || '—'}
                  <div className="sub">{r.virtual ? '— đơn ảo —' : r.billCode}</div>
                </td>
                <td>
                  {r.custName || r.custCode}
                  <div className="sub">{r.saleName}</div>
                </td>
                <td className={`r ${(r.price || 0) < 0 ? 'neg' : ''}`}>{vnd(r.price)}</td>
                <td className="r">{vnd(r.feeShip)}</td>
                <td className="r">{vnd(r.feeOther)}</td>
                <td>
                  {r.excluded ? (
                    <>
                      <span className="tag danger">Loại trừ</span>
                      <div className="sub">{r.excludedBy}{r.excludedAt ? ` · ${new Date(r.excludedAt).toLocaleString('vi-VN', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}` : ''}</div>
                    </>
                  ) : (
                    <>
                      {/* GỢI Ý: đơn nghi thanh toán hộ — kèm nguyên văn tên hàng/ghi chú để kế toán tự thẩm định. */}
                      {r.payOnBehalf && (
                        <>
                          <span className="tag warn">⚠ Nghi thanh toán hộ — nên loại trừ</span>
                          <div className="sub" title={`${r.productName || ''} ${r.groupNote || ''}`.trim()}>
                            {(r.groupNote || r.productName || '').slice(0, 90)}
                          </div>
                        </>
                      )}
                      {r.codAmount ? (
                        <span className="tag accent">COD {vnd(r.codAmount)}đ · lương {vnd(r.codAmount * 0.003)}đ</span>
                      ) : r.refundNote ? (
                        <span className={`tag ${r.virtual ? 'danger' : 'warn'}`}>{r.refundNote}</span>
                      ) : !r.payOnBehalf ? (
                        <span className="sub">—</span>
                      ) : null}
                    </>
                  )}
                </td>
                <td className="r">
                  {!data.locked && (
                    <button className={r.excluded ? '' : 'srt-x'} onClick={() => toggle(r)}>
                      {r.excluded ? 'Bỏ loại trừ' : 'Loại trừ'}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="scanrows-foot">
        <div className="srf-size">
          <span>Hiện</span>
          {[20, 50, 100, 200].map((n) => (
            <button key={n} className={size === n ? 'active' : ''} onClick={() => setSize(n)}>{n}</button>
          ))}
          <span>đơn / trang</span>
        </div>
        <div className="srf-page">
          <span>{data.total ? `${(page - 1) * size + 1}–${Math.min(page * size, data.total)} / ${vnd(data.total)}` : '0 đơn'}</span>
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>‹</button>
          <span>{page} / {pages}</span>
          <button disabled={page >= pages} onClick={() => setPage((p) => p + 1)}>›</button>
        </div>
      </div>
    </div>
  );
}
